import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";

import ReactToPrint from "react-to-print";
import {
  getSalesReportByInvoiceCount,
  getEcommerceSales,
} from "../../../actions/report";
import { getAllOutlet, getAllLocationPlain } from "../../../actions/warehouseAction";
import { getAllAccount } from "../../../actions/accountsAction";

import RenderTable from "./RenderTable";
import Excelldownload from "./Excelldownload";
import dateFormat from "dateformat";
import CashRegister from "./CashRegister";

import { Layout, Breadcrumb, Row, Col, DatePicker, Select, Divider, Skeleton, Card, Button, AutoComplete,  Spin,} from "antd";
const { Content } = Layout;
const { RangePicker } = DatePicker;
const { Option } = Select;

const SalesReport = ({  getEcommerceSales, getAllLocationPlain, getAllAccount, businessprofile, Auth,
}) => {
  var formatter = new Intl.NumberFormat("en-IN");
  const componentRef = useRef();
  const [data, setData] = useState([]);
  const [data1, setData1] = useState([]);
  const [allDataForPDF, setAllDataForPDF] = useState([]);
  const [accounts, setaccounts] = useState([]);
  const [outletlist, setoutletlist] = useState([]);
  const [loading, setloading] = useState(true);
  const [loadingPDF, setLoadingPDF] = useState(false);
  const [reload, setreload] = useState(false);
  const [type, setType] = useState("date");
  const [selectedOutlet, setSelectedOutlet] = useState(""); 
  const from = useRef("2021-01-01");
  const to = useRef("2071-01-01");
  const start = useRef("");
  const end = useRef("");
  const keyward = useRef("");
  const status = useRef("");
  const account = useRef("");
  const location = useRef("");
  const pageno = useRef(1);
  const page_size = useRef(10);
  let total_payments = useRef([]);
  let total_data = useRef({});
  const printButtonRef = useRef();

  useEffect(() => {
    // First fetch the outlets
    getAllLocationPlain().then((result) => {
      console.log(result);
      setoutletlist(result);
      
      // Find and set ecommerce outlet as default
      const ecommerceOutlet = result.find(outlet => 
        outlet.name.toLowerCase() === "ecommerce"
      );
      
      if (ecommerceOutlet) {
        location.current = ecommerceOutlet.id;
        setSelectedOutlet(ecommerceOutlet.id); 
      }
      
      // Fetch accounts
      return getAllAccount();
    }).then((result) => {
      console.log(result);
      setaccounts(result);
      

      return getEcommerceSales(
        start.current,
        end.current,
        keyward.current,
        "",
        "",
        "",
        status.current,
        "",
        location.current,
        account.current,
        pageno.current,
        page_size.current
      );
    }).then(function (result) {
      total_data.current = {
        total_invoices: result.count,
        total_sales: result.total_sales,
        total_payment: result.total_payment,
        total_due: result.total_due,
        total_tax: result.total_tax,
        total_costing: result.total_costing,
        total_discount: result.total_discount,
        current_page_discount: result.current_page_discount,
        total_additional_discount: result.total_additional_discount,
        current_page_additional_discount: result.current_page_additional_discount,
        total_combined_discount: result.total_combined_discount,
        total_invoice_bill:result.total_invoice_bill,
        current_page_tax: result.current_page_tax,
        current_page_costing: result.current_page_costing,
        current_page_due: result.current_page_due,
        current_page_payment: result.current_page_payment,
        current_page_sales: result.current_page_sales,
      };
      setData(result);
      setloading(false);
    });
  }, [reload]);

  const onChange = (event) => {
    if (event.keyCode == 13) {
      pageno.current = 1;
      keyward.current = event.target.value;
    }
  };

  // Fetch all data for PDF
  const fetchAllDataForPDF = async () => {
    setLoadingPDF(true);
    try {
      const result = await getEcommerceSales(
        start.current,
        end.current,
        keyward.current,
        "",
        "",
        "",
        status.current,
        "",
        location.current,
        account.current,
        1, // page number
        10000 // large page size to get all records
      );
      
      setAllDataForPDF(result.results);
      
      // Update total data for PDF
      total_data.current = {
        total_invoices: result.count,
        total_sales: result.total_sales,
        total_payment: result.total_payment,
        total_due: result.total_due,
        total_tax: result.total_tax,
        total_costing: result.total_costing,
        total_discount: result.total_discount,
        current_page_discount: result.current_page_discount,
        total_additional_discount: result.total_additional_discount,
        current_page_additional_discount: result.current_page_additional_discount,
        total_combined_discount: result.total_combined_discount,
        total_invoice_bill: result.total_invoice_bill,
        current_page_tax: result.current_page_tax,
        current_page_costing: result.current_page_costing,
        current_page_due: result.current_page_due,
        current_page_payment: result.current_page_payment,
        current_page_sales: result.current_page_sales,
      };
      
      setLoadingPDF(false);
      
      // Trigger print after data is loaded
      setTimeout(() => {
        if (printButtonRef.current) {
          printButtonRef.current.click();
        }
      }, 100);
    } catch (error) {
      console.error("Failed to fetch data for PDF:", error);
      setLoadingPDF(false);
      alert("Failed to load data for PDF");
    }
  };

  const SwitchablePicker = () => {
    return (
      <Row wrap={false}>
        <Col span={3}>
        <h5>keyword :</h5>
          <AutoComplete
            placeholder="input search text"
            onKeyUp={onChange}
            style={{ width: "100%", minWidth: "140px" }}
          />
        </Col>
        <Col span={3}>
          <h5>Method :</h5>
          <Select
            placeholder="Payment Method"
            style={{ width: "100%" }}
            onChange={(e) => {
              console.log(e);
              account.current = e;
            }}
          >
            <Option value="">All</Option>
            {accounts.map((acc) => {
              return <Option key={acc.id} value={acc.id}>{acc.name}</Option>;
            })}
          </Select>
        </Col>
        <Col span={5}>
        <h5>Issue date :</h5>
          <RangePicker
            style={{ width: "100%" }}
            picker={type}
            onChange={(value) => {
              if (value) {
                console.log(value);
                from.current = value[0].format("YYYY-MM-DD");
                to.current = value[1].format("YYYY-MM-DD");
                start.current = value[0].format("YYYY-MM-DD") + "T00:00:00";
                end.current = value[1].format("YYYY-MM-DD") + "T23:59:59";
              }
            }}
          />
        </Col>
        <Col span={3}>
        <h5>Status :</h5>
          <Select
            style={{ width: "100%" }}
            placeholder="Status"
            onChange={(value) => {
              status.current = value;
            }}
          >
            <Option value="">All</Option>
            <Option value="Pending">Pending</Option>
            <Option value="Factory Received">Factory received</Option>
            <Option value="Outlet received">Outlet received</Option>
            <Option value="Ready">Ready</Option>
            <Option value="Picked by courier">Picked by courier</Option>
            <Option value="Delivered">Delivered</Option>
            <Option value="Paid">Paid</Option>
            <Option value="Booked">Booked</Option>
            <Option value="Exchanged">Exchanged</Option>
            <Option value="Cancelled">Cancelled</Option>
          </Select>
        </Col>
        <Col span={4}>
        <h5>Outlet:</h5> 
        <Select
          placeholder="Ecommerce"
          style={{ width: "100%" }}
          value={selectedOutlet || undefined}
          disabled={true} 
          onChange={(e) => {
            console.log(e);
            location.current = e;
            setSelectedOutlet(e);
          }}
        >
          {outletlist
            .filter(outlet => outlet.name.toLowerCase() === "ecommerce")
            .map((outlet) => {
              return <Option key={outlet.id} value={outlet.id}>{outlet.name}</Option>;
            })
          }
        </Select>
        </Col>
        <Col span={2}>
        <h5 style={{color:"white"}}> .</h5> 
          <Button type="primary" style={{ width: "100%", marginRight: "4px" }} onClick={() => {
            setloading(true);
            setreload(!reload);
          }}>Search</Button>
        </Col>
        <Col span={2}>
        <h5 style={{color:"white"}}> .</h5> 
          <Excelldownload data={data.results} data1={data1} />
        </Col>
        <Col span={2}>
        <h5 style={{color:"white"}}> .</h5> 
          <Spin spinning={loadingPDF}>
            <Button 
              type="ghost" 
              style={{ width: "100%", marginLeft: "4px" }}
              onClick={fetchAllDataForPDF}
              disabled={loadingPDF}
            >
              {loadingPDF ? "Loading..." : "Print All"}
            </Button>
          </Spin>
          
          {/* Hidden ReactToPrint button */}
          <div style={{ display: "none" }}>
            <ReactToPrint
              trigger={() => <button ref={printButtonRef}>Print</button>}
              content={() => componentRef.current}
              onAfterPrint={() => setAllDataForPDF([])}
            />
          </div>
        </Col>
      </Row>
    );
  };
  
  const resultrender = () => {
    return (
      <Row>
        <Divider />

        <Col span={24}>
          <CashRegister
            location={location}
            loading={loading}
            setloading={setloading}
            reload={reload}
            setreload={setreload}
            start={start}
            end={end}
            collectionType={"Due"}
            total_data={total_data}
          />
        </Col>

        <Col span={2}>
          <div style={{ display: "none" }}>
            <div
              className="invoice_print_fontSize"
              ref={componentRef}
              style={{ padding: "10px" }}
            >
              <Row
                style={{
                  borderBottom: "2px solid lightgray",
                  paddingBottom: "5px",
                  marginBottom: "20px",
                }}
              >
                <Col span={17} style={{ paddingTop: "10px" }}>
                  <small>
                    <div
                      style={{ lineHeight: "2.5px" }}
                      dangerouslySetInnerHTML={{
                        __html: businessprofile.address,
                      }}
                    ></div>
                  </small>
                </Col>

                <Col span={7} style={{ textAlign: "right" }}>
                  <h2>{businessprofile.business_name}</h2>
                </Col>
              </Row>

              <h3 style={{ textAlign: "center" }}>Sales Report</h3>
              <Row style={{ marginBottom: "15px" }}>
                <Col span={12} style={{ textAlign: "left" }}>
                  <div style={{ 
                    display: "inline-block",
                    padding: "10px 15px",
                    border: "1px solid #d9d9d9",
                    borderRadius: "4px",
                    backgroundColor: "#fafafa"
                  }}>
                    <div style={{ marginBottom: "5px" }}>
                      <span style={{ color: "#666", marginRight: "10px" }}>Total Invoices:</span>
                      <strong style={{ fontSize: "14px" }}>{formatter.format(total_data.current["total_invoices"])}</strong>
                    </div>
                    <div style={{ marginBottom: "5px" }}>
                      <span style={{ color: "#666", marginRight: "10px" }}>Total Sales:</span>
                      <strong style={{ fontSize: "14px" }}>{formatter.format(total_data.current["total_sales"])}</strong>
                    </div>
                    <div style={{ marginBottom: "5px" }}>
                      <span style={{ color: "#666", marginRight: "10px" }}>Total Payment:</span>
                      <strong style={{ fontSize: "14px" }}>{formatter.format(total_data.current["total_payment"])}</strong>
                    </div>
                    <div style={{ marginBottom: "5px" }}>
                      <span style={{ color: "#666", marginRight: "10px" }}>Total Due:</span>
                      <strong style={{ fontSize: "14px" }}>{formatter.format(total_data.current["total_due"])}</strong>
                    </div>
                    <div>
                      <span style={{ color: "#666", marginRight: "10px" }}>Total Discount:</span>
                      <strong style={{ fontSize: "14px" }}>{formatter.format(total_data.current["total_discount"])}</strong>
                    </div>
                  </div>
                </Col>
                <Col span={12} style={{ textAlign: "right" }}>
                  <div>
                    {start.current != "" ? (
                      <>
                        <strong>From:</strong> {dateFormat(start.current, "mmmm dS, yyyy")}
                        <br />
                      </>
                    ) : (
                      ""
                    )}
                    {end.current != "" ? (
                      <>
                        <strong>To:</strong> {dateFormat(end.current, "mmmm dS, yyyy")}
                        <br />
                      </>
                    ) : (
                      ""
                    )}
                    {outletlist.map((outlet) => {
                      if (outlet.id == location.current)
                        return <span key={outlet.id}><strong>Outlet:</strong> {outlet.name}</span>;
                    })}
                  </div>
                </Col>
              </Row>

              <br />

              <table className="product_table invoice_print_fontSize">
                <thead>
                  <tr>
                    <th>SL.</th>
                    <th>Date</th>
                    <th>Order No.</th>
                    <th>Discount</th>
                    <th>Bill</th>
                    <th>Payment</th>
                    <th>Due</th>
                  </tr>
                </thead>
                <tbody>
                  {(allDataForPDF.length > 0 ? allDataForPDF : data.results || []).map((item, index) => {
                    return (
                      <tr key={item.id || index}>
                        <td>{index + 1}</td>
                        <td>{item.issue_date}</td>
                        <td>{item.order_number}</td>
                        <td>{formatter.format(item.discount)}</td>
                        <td>{formatter.format(item.bill)}</td>
                        <td>{formatter.format(item.payment)}</td>
                        <td>{formatter.format(item.due)}</td>
                      </tr>
                    );
                  })}
                  <tr>
                    <td colSpan={3}><strong>Total:</strong></td>
                    <td><strong>{formatter.format(total_data.current["total_discount"])}</strong></td>
                    <td><strong>{formatter.format(total_data.current["total_sales"])}</strong></td>
                    <td><strong>{formatter.format(total_data.current["total_payment"])}</strong></td>
                    <td><strong>{formatter.format(total_data.current["total_due"])}</strong></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </Col>
      </Row>
    );
  };

  const Rendercontent = () => {
    if (loading) {
      return (
        <>
          <Skeleton active />
          <Skeleton active />
          <Skeleton active />
          <Skeleton active />
          <Skeleton active />
        </>
      );
    } else {
      return (
        <>
          {resultrender()}
        </>
      );
    }
  };
  
  return (
    <>
      <Breadcrumb style={{ margin: "16px 0" }}>
        <Breadcrumb.Item>Report</Breadcrumb.Item>
      </Breadcrumb>
      <div className="site-layout-background main-frame">
        <Row>
          <Col
            span={24}
            style={{ padding: "1rem", border: "1px solid whitesmoke" }}
          >
            {SwitchablePicker()}
            {Rendercontent()}
            <Divider />
            <Spin spinning={loading} >
              <RenderTable
                List={data}
                pageno={pageno}
                page_size={page_size}
                setreload={setreload}
                reload={reload}
                setloading={setloading}
                total_data={total_data}
              />
            </Spin>
          </Col>
        </Row>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    businessprofile: state.settings.businessprofile,
    Auth: state.auth,
  };
};

export default connect(mapStateToProps, {
  getSalesReportByInvoiceCount,
  getEcommerceSales,
  getAllOutlet,
  getAllAccount,
  getAllLocationPlain,
})(SalesReport);